"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onDemandCustomChoices = void 0;
const choices_1 = require("../../common/choices");
const helpers_1 = require("evolution-common/lib/services/odSurvey/helpers");
// FIXME This is copied from the `onDemandChoices` type in choices.tsx. It was
// copied from there because a choice required the nickname
exports.onDemandCustomChoices = [
    {
        value: 'pickupAtOrigin',
        label: (t, interview, path) => {
            const activePerson = (0, helpers_1.getPerson)({ interview, path });
            const nickname = (activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname');
            return t('segments:onDemandChoicesPickupAtOrigin', {
                nickname,
                count: (0, helpers_1.countPersons)({ interview })
            });
        }
    },
    {
        value: 'joinedStop',
        label: (t, interview, path) => {
            const activePerson = (0, helpers_1.getPerson)({ interview, path });
            const nickname = (activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname');
            return t('segments:onDemandChoicesJoinedStop', {
                nickname,
                count: (0, helpers_1.countPersons)({ interview })
            });
        }
    },
    ...choices_1.no
];
